import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { AppModule } from "./app/app.module";
import { MX } from "./environments/environment";

function isInIframe(): boolean {
  try {
    /**
     * Leaving this line for debugging purposes
     */
    // let appPath = window.self.origin;
    const notifyAppParentURLLower = MX.notifyAppParentURL.toLowerCase();
    if (
      document.location.ancestorOrigins &&
      document.location.ancestorOrigins.length > 0
    ) {
      let parentAppPathAncestorOrigin = "";

      try {
        parentAppPathAncestorOrigin =
          document.location.ancestorOrigins["0"].toLowerCase();
      } catch (e) {}

      if (
        parentAppPathAncestorOrigin &&
        !parentAppPathAncestorOrigin.includes(notifyAppParentURLLower)
      ) {
        return false;
      }
    }

    if (
      !document.location.ancestorOrigins ||
      document.location.ancestorOrigins.length == 0
    ) {
      return false;
    }

    if (document.referrer) {
      let parentAppPathReferrer = document.referrer.toLowerCase();

      if (
        parentAppPathReferrer &&
        !parentAppPathReferrer.includes(notifyAppParentURLLower + "/")
      ) {
        return false;
      }
    }

    return true;
  } catch {
    return true;
  }
}

if (!isInIframe()) {
  document.body.innerHTML = `
    <div style="
      height: 100vh;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #0f172a;
      color: white;
      font-family: system-ui, sans-serif;
      text-align: center;
      padding: 20px;
    ">
      <div>
        <h1 style="margin-bottom: 12px;">🚫 Access Restricted</h1>
        <p>This page can't be opened directly.</p>
        <p>Please access it through your organization's portal or application.</p>
      </div>
    </div>
  `;

  console.error(
    "This page can't be opened directly. Please access it through your organization's portal or application.",
  );
} else {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
}
